module.exports = __webpack_public_path__ + "img/s2_stepimg02-s.003083f8.png";